import { renderMarkdown } from "./markdown";

/**
 * Writes rich text (text/html) AND plain text to the clipboard so Word/Outlook paste
 * formatted content. Falls back to plain text when the rich clipboard API is unavailable.
 */
export async function writeRichText(html: string, plain: string): Promise<void> {
  const clip = navigator.clipboard as Clipboard | undefined;
  const CI = (window as unknown as { ClipboardItem?: typeof ClipboardItem }).ClipboardItem;

  if (clip && typeof clip.write === "function" && typeof CI === "function") {
    const item = new CI({
      "text/html": new Blob([`<meta charset="utf-8">${html}`], { type: "text/html" }),
      "text/plain": new Blob([plain], { type: "text/plain" }),
    });
    await clip.write([item]);
    return;
  }
  if (clip && typeof clip.writeText === "function") {
    await clip.writeText(plain);
  }
}

/** Renders markdown → sanitized HTML and copies it as rich text (plain = the markdown source). */
export async function copyMarkdownRich(markdown: string): Promise<void> {
  await writeRichText(renderMarkdown(markdown), markdown);
}
